import baiduLogo from "simple-icons/icons/baidu.svg";
import bilibiliLogo from "simple-icons/icons/bilibili.svg";
import doubanLogo from "simple-icons/icons/douban.svg";
import githubLogo from "simple-icons/icons/github.svg";
import juejinLogo from "simple-icons/icons/juejin.svg";
import weiboLogo from "simple-icons/icons/sinaweibo.svg";
import douyinLogo from "simple-icons/icons/tiktok.svg";
import v2exLogo from "simple-icons/icons/v2ex.svg";
import wechatLogo from "simple-icons/icons/wechat.svg";
import zhihuLogo from "simple-icons/icons/zhihu.svg";
import type { CSSProperties } from "react";
import type { Platform } from "../types";

const vectorLogos: Partial<Record<string, string>> = {
  zhihu: zhihuLogo,
  weibo: weiboLogo,
  baidu: baiduLogo,
  wechat: wechatLogo,
  douyin: douyinLogo,
  bilibili: bilibiliLogo,
  v2ex: v2exLogo,
  juejin: juejinLogo,
  github: githubLogo,
  douban: doubanLogo,
};

const faviconLogos: Partial<Record<string, string>> = {
  toutiao: "https://www.toutiao.com/favicon.ico",
  "36kr": "https://36kr.com/favicon.ico",
  huxiu: "https://www.huxiu.com/favicon.ico",
  sspai: "https://cdn-static.sspai.com/favicon/sspai.ico",
  ithome: "https://www.ithome.com/favicon.ico",
  thepaper: "https://www.thepaper.cn/favicon.ico",
  netease: "https://news.163.com/favicon.ico",
  tencent: "https://news.qq.com/favicon.ico",
  "52pojie": "https://www.52pojie.cn/favicon.svg",
  tieba: "https://tieba.baidu.com/favicon.ico",
  hupu: "https://bbs.hupu.com/favicon.ico",
  xueqiu: "https://xueqiu.com/favicon.ico",
  eastmoney: "https://guba.eastmoney.com/favicon.ico",
  smzdm: "https://www.smzdm.com/favicon.ico",
  wallstreetcn: "https://wallstreetcn.com/favicon.ico",
};

interface PlatformLogoProps {
  platform: Platform;
}

export function PlatformLogo({ platform }: PlatformLogoProps) {
  const vectorLogo = vectorLogos[platform.id];
  const faviconLogo = faviconLogos[platform.id];
  const style = { "--platform-color": platform.color } as CSSProperties;

  if (vectorLogo) {
    return (
      <span aria-hidden="true" className="platform-logo is-vector" style={style}>
        <span
          className="platform-logo-mask"
          style={{
            WebkitMaskImage: `url("${vectorLogo}")`,
            maskImage: `url("${vectorLogo}")`,
          }}
        />
      </span>
    );
  }

  return (
    <span aria-hidden="true" className={`platform-logo ${faviconLogo ? "is-favicon" : "is-letter"}`} style={style}>
      <span className="platform-logo-fallback">{platform.shortName}</span>
      {faviconLogo ? (
        <img
          alt=""
          decoding="async"
          loading="lazy"
          onError={(event) => { event.currentTarget.hidden = true; }}
          src={faviconLogo}
        />
      ) : null}
    </span>
  );
}
